<ng-template #jamfPopover
  >Find your credentials on
  <a
    tabindex="0"
    class="madero-link u_clickable"
    [href]="JAMF_URL"
    target="_blank"
    >JAMF Pro</a
  >.
</ng-template>
<ng-template #mosylePopover
  >Find your credentials on
  <a
    tabindex="0"
    class="madero-link u_clickable"
    [href]="MOSYLE_URL"
    target="_blank"
    >Mosyle</a
  >.
</ng-template>
<div
  id="integrations"
  class="settings-page-container"
  rvSpinner="integrations"
  [rvShowSpinner]="loading"
>
  <form
    #companyForm="ngForm"
    id="forms.integrationsCompanyForm"
    role="form"
    name="forms.integrationsCompanyForm"
    class="integrations-form"
    (ngSubmit)="save()"
    autocomplete="on"
    novalidate
  >
    <div class="settings-page-body">
      <div class="settings-page-section">
        <div>
          <div>
            <div>
              <h2 class="tw-text-[14px] tw-font-semibold tw-text-gray-900">
                FUSE Display Management
              </h2>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-12">
              <div class="flex-row left-right-aligner">
                <label
                  id="company-settings-fuseenabled-label"
                  for="company-settings-fuseenabled"
                  class="control-label tw-font-normal"
                >
                  Enable Avocor FUSE
                </label>
                <mat-slide-toggle
                  class="mb-2"
                  name="fuseEnabled"
                  id="company-settings-fuseenabled"
                  [(ngModel)]="company.settings.fuseEnabled"
                  aria-labelledby="company-settings-fuseenabled-label"
                  (change)="updateEditableFields()"
                  [attr.aria-pressed]="company.settings.fuseEnabled"
                >
                </mat-slide-toggle>
              </div>
            </div>
          </div>
          @if (company.settings.fuseEnabled) {
            <div>
              <div class="pt-3 border-top">
                <div class="form-group">
                  <label
                    for="company-settings-fuseapikey"
                    class="control-label tw-font-normal"
                  >
                    FUSE API Key
                  </label>
                  <div class="flex-row left-right-aligner">
                    <input
                      id="company-settings-fuseapikey"
                      name="company-settings-fuseapikey"
                      #fuseapikey="ngModel"
                      required
                      type="text"
                      class="form-control"
                      placeholder="API Key"
                      [readonly]="!fuseApiKeyEditable"
                      [(ngModel)]="company.settings.fuseApiKey"
                    />
                    @if (!fuseApiKeyEditable) {
                      <button
                        type="button"
                        aria-label="Edit FUSE API Key"
                        class="btn btn-default-icon pl-3 pr-3 ml-2"
                        (click)="editFuseApiKey()"
                      >
                        <streamline-icon
                          name="pencil"
                          width="12"
                          height="12"
                        ></streamline-icon>
                      </button>
                    }
                  </div>
                  <p
                    [shown]="
                      (fuseapikey.dirty || companyForm?.submitted) &&
                      fuseapikey.errors?.required
                    "
                    class="help-block validation-error-message-name text-danger"
                  >
                    FUSE API Key is required.
                  </p>
                </div>
              </div>
              <div class="tw-mb-8">
                <span class="instructions">
                  Enter your API Key from
                  <a
                    href="https://fuse.avocor.com/settings/api_keys?page=1"
                    target="_blank"
                    >https://fuse.avocor.com/settings/api_keys?page=1</a
                  >
                </span>
              </div>
            </div>
          }
        </div>
        <mat-divider class="-tw-mx-10 tw-mb-6 tw-border-gray-100"></mat-divider>
        <div class="row">
          <div class="col-md-12 mb-2">
            <h2 class="tw-text-[14px] tw-font-semibold tw-text-gray-900">
              Apple TV MDM
            </h2>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-12">
            <div class="flex-row left-right-aligner">
              <label
                id="company-settings-jamfenabled-label"
                for="company-settings-jamfenabled"
                class="control-label tw-font-normal"
              >
                Enable JAMF Pro
                <streamline-icon
                  tabindex="0"
                  name="help"
                  class="help"
                  [outsideClick]="true"
                  [popover]="jamfPopover"
                  triggers="mouseenter:click focus:click"
                  (keyup.enter)="redirect(JAMF_URL)"
                  (onShown)="onPopoverShown($event)"
                  ariaLabel="Show Enable JAMF Pro Tooltip"
                  id="jamf-tooltip"
                  aria-describedby="jamf-tooltip-popover"
                  #jamfTooltip
                >
                </streamline-icon>
              </label>
              <mat-slide-toggle
                tabindex="0"
                class="mb-2"
                name="jamfEnabled"
                id="company-settings-jamfenabled"
                aria-describedby="jamf-tooltip"
                [(ngModel)]="company.settings.jamfEnabled"
                aria-labelledby="company-settings-jamfenabled-label"
                (change)="updateEditableFields()"
                [disabled]="company.settings.mosyleEnabled"
                [attr.aria-pressed]="company.settings.jamfEnabled"
                [attr.aria-disabled]="company.settings.mosyleEnabled"
              >
              </mat-slide-toggle>
            </div>
          </div>
        </div>

        <div class="tw-mb-8">
          <div class="flex-row left-right-aligner">
            <label
              id="company-settings-mosyleenabled-label"
              for="company-settings-mosyleenabled"
              class="control-label tw-font-normal"
            >
              Enable Mosyle
              <streamline-icon
                tabindex="0"
                name="help"
                class="help"
                [outsideClick]="true"
                [popover]="mosylePopover"
                triggers="mouseenter:click focus:click"
                (keyup.enter)="redirect(MOSYLE_URL)"
                (onShown)="onPopoverShown($event)"
                ariaLabel="Show Enable Mosyle Tooltip"
                id="mosyle-tooltip"
                #mosyleTooltip
              >
              </streamline-icon>
            </label>
            <mat-slide-toggle
              tabindex="0"
              class="mb-2"
              name="mosyleEnabled"
              id="company-settings-mosyleenabled"
              aria-describedby="mosyle-tooltip"
              aria-labelledby="company-settings-mosyleenabled-label"
              [(ngModel)]="company.settings.mosyleEnabled"
              (change)="updateEditableFields()"
              [disabled]="company.settings.jamfEnabled"
              [attr.aria-pressed]="company.settings.mosyleEnabled"
              [attr.aria-disabled]="company.settings.jamfEnabled"
            >
            </mat-slide-toggle>
          </div>
        </div>
        @if (company.settings.mosyleEnabled) {
          <div class="border-top tw-pt-8 tw-pb-4">
            <div class="form-group">
              <label
                for="company-settings-mosyleadminemail"
                class="control-label tw-font-normal"
              >
                Admin Email
              </label>
              <input
                id="company-settings-mosyleadminemail"
                name="company-settings-mosyleadminemail"
                #mosyleadminemail="ngModel"
                required
                type="text"
                class="form-control"
                [pattern]="EMAIL_REGEX"
                placeholder="Admin Email"
                [(ngModel)]="company.settings.mosyleEmail"
              />
              <p
                [shown]="
                  (mosyleadminemail.dirty || companyForm?.submitted) &&
                  mosyleadminemail.errors?.required
                "
                class="help-block validation-error-message-admin-email text-danger"
              >
                Mosyle Admin Email is required.
              </p>
              <p
                [shown]="
                  (mosyleadminemail.dirty || companyForm?.submitted) &&
                  mosyleadminemail.errors?.pattern
                "
                class="help-block validation-error-message-admin-email text-danger"
              >
                Mosyle Admin Email is invalid.
              </p>
            </div>
            <div class="form-group">
              <label
                for="company-settings-mosylepassword"
                class="control-label tw-font-normal"
              >
                Password
              </label>
              <input
                id="company-settings-mosylepassword"
                name="company-settings-mosylepassword"
                #mosylepassword="ngModel"
                required
                type="password"
                class="form-control"
                placeholder="Password"
                [(ngModel)]="company.settings.mosylePassword"
              />
              <p
                [shown]="
                  (mosylepassword.dirty || companyForm?.submitted) &&
                  mosylepassword.errors?.required
                "
                class="help-block validation-error-message-password text-danger"
              >
                Mosyle Password is required.
              </p>
            </div>
            <div class="form-group">
              <label
                for="company-settings-mosyleaccesstoken"
                class="control-label tw-font-normal"
              >
                Access Token
              </label>
              <div class="flex-row left-right-aligner">
                <input
                  id="company-settings-mosyleaccesstoken"
                  name="company-settings-mosyleaccesstoken"
                  #mosyleaccesstoken="ngModel"
                  required
                  type="text"
                  class="form-control"
                  placeholder="Access Token"
                  [readonly]="!mosyleAccessTokenEditable"
                  [(ngModel)]="company.settings.mosyleAccessToken"
                />
                @if (!mosyleAccessTokenEditable) {
                  <button
                    type="button"
                    aria-label="Edit Mosyle access token"
                    class="btn btn-default-icon pl-3 pr-3 ml-2"
                    (click)="editMosyleAccessToken()"
                  >
                    <streamline-icon
                      name="pencil"
                      width="12"
                      height="12"
                    ></streamline-icon>
                  </button>
                }
              </div>
              <p
                [shown]="
                  (mosyleaccesstoken.dirty || companyForm?.submitted) &&
                  mosyleaccesstoken.errors?.required
                "
                class="help-block validation-error-message-access-token text-danger"
              >
                Mosyle Access Token is required.
              </p>
            </div>
          </div>
        }
        @if (company.settings.jamfEnabled) {
          <div class="border-top tw-pt-8 tw-pb-4">
            <div class="form-group">
              <label
                for="company-settings-jamfdomain"
                class="control-label tw-font-normal"
              >
                JAMF Pro Server
              </label>
              <input
                id="company-settings-jamfdomain"
                name="company-settings-jamfdomain"
                #jamfdomain="ngModel"
                required
                type="text"
                class="form-control"
                [pattern]="WEBSITE_REGEX"
                placeholder="Domain"
                [(ngModel)]="company.settings.jamfDomain"
              />
              <p
                [shown]="
                  (jamfdomain.dirty || companyForm?.submitted) &&
                  jamfdomain.errors?.required
                "
                class="help-block validation-error-message-domain text-danger"
              >
                Jamf Domain is required.
              </p>
              <p
                [shown]="
                  (jamfdomain.dirty || companyForm?.submitted) &&
                  jamfdomain.errors?.pattern
                "
                class="help-block validation-error-message-domain text-danger"
              >
                Jamf Domain is invalid.
              </p>
            </div>
            <div class="form-group">
              <label
                for="company-settings-jamfclientid"
                class="control-label tw-font-normal"
              >
                Client ID
              </label>
              <input
                id="company-settings-jamfclientid"
                name="company-settings-jamfclientid"
                #jamfclientid="ngModel"
                required
                type="text"
                class="form-control"
                placeholder="Client Id"
                [(ngModel)]="company.settings.jamfClientId"
              />
              <p
                [shown]="
                  (jamfclientid.dirty || companyForm?.submitted) &&
                  jamfclientid.errors?.required
                "
                class="help-block validation-error-message-client-id text-danger"
              >
                Jamf Client Id is required.
              </p>
            </div>
            <div class="form-group">
              <label
                for="company-settings-jamfclientsecret"
                class="control-label tw-font-normal"
              >
                Client Secret
              </label>
              <div class="flex-row left-right-aligner">
                <input
                  id="company-settings-jamfclientsecret"
                  name="company-settings-jamfclientsecret"
                  #jamfclientsecret="ngModel"
                  required
                  type="text"
                  class="form-control"
                  placeholder="Client Secret"
                  [readonly]="!jamfSecretEditable"
                  [(ngModel)]="company.settings.jamfClientSecret"
                />
                @if (!jamfSecretEditable) {
                  <button
                    type="button"
                    aria-label="Edit JAMF client secret"
                    class="btn btn-default-icon pl-3 pr-3 ml-2"
                    (click)="editJamfSecret()"
                  >
                    <streamline-icon
                      name="pencil"
                      width="12"
                      height="12"
                    ></streamline-icon>
                  </button>
                }
              </div>
              <p
                [shown]="
                  (jamfclientsecret.dirty || companyForm?.submitted) &&
                  jamfclientsecret.errors?.required
                "
                class="help-block validation-error-message-name text-danger"
              >
                Jamf Client Secret is required.
              </p>
            </div>
          </div>
        }
        <mat-divider class="-tw-mx-10 tw-mb-6 tw-border-gray-100"></mat-divider>
        <div class="row">
          <div class="col-md-12 mb-2">
            <h2 class="tw-text-[14px] tw-font-semibold tw-text-gray-900">
              Domo Dashboards
            </h2>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="flex-row left-right-aligner">
              <label
                id="company-settings-domoenabled-label"
                for="company-settings-domoenabled"
                class="control-label tw-font-normal"
              >
                Enable Domo
              </label>
              <mat-slide-toggle
                class="mb-2"
                name="domoEnabled"
                id="company-settings-domoenabled"
                [(ngModel)]="company.settings.domoEnabled"
                aria-labelledby="company-settings-domoenabled-label"
                (change)="updateEditableFields()"
                [attr.aria-pressed]="company.settings.domoEnabled"
              >
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        @if (company.settings.domoEnabled) {
          <div class="border-top tw-pt-8 tw-pb-4">
            <div class="form-group">
              <label
                for="company-settings-domoclientid"
                class="control-label tw-font-normal"
              >
                Client ID
              </label>
              <input
                id="company-settings-domoclientid"
                name="company-settings-domoclientid"
                #domoclientid="ngModel"
                required
                type="text"
                class="form-control"
                placeholder="Client ID"
                [(ngModel)]="company.settings.domoClientId"
              />
              <p
                [shown]="
                  (domoclientid.dirty || companyForm?.submitted) &&
                  domoclientid.errors?.required
                "
                class="help-block validation-error-message-name text-danger"
              >
                Domo Client ID is required.
              </p>
            </div>
            <div class="form-group">
              <label
                for="company-settings-domoclientsecret"
                class="control-label tw-font-normal"
              >
                Client Secret
              </label>
              <div class="flex-row left-right-aligner">
                <input
                  id="company-settings-domoclientsecret"
                  name="company-settings-domoclientsecret"
                  #domoclientsecret="ngModel"
                  required
                  type="password"
                  class="form-control"
                  placeholder="Client Secret"
                  [readonly]="!domoClientSecretEditable"
                  [(ngModel)]="company.settings.domoClientSecret"
                  (blur)="onDomoClientSecretBlur()"
                />
                @if (!domoClientSecretEditable) {
                  <button
                    mat-icon-button
                    class="tw-ml-1 tw-border-solid tw-rounded-lg tw-border-gray-200"
                    type="button"
                    aria-label="Edit Domo secret"
                    (click)="editDomoClientSecret()"
                  >
                    <mat-icon svgIcon="edit" class="small" />
                  </button>
                }
              </div>
              <p
                [shown]="
                  (domoclientsecret.dirty || companyForm?.submitted) &&
                  domoclientsecret.errors?.required
                "
                class="help-block validation-error-message-name text-danger"
              >
                Domo Client Secret is required.
              </p>
            </div>
          </div>
        }
        <ng-container>
          <mat-divider
            class="-tw-mx-10 tw-mb-6 tw-border-gray-100"
          ></mat-divider>
          <div class="row">
            <div class="col-md-12 mb-2">
              <h2 class="tw-text-[14px] tw-font-semibold tw-text-gray-900">
                Ad Astra
              </h2>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-12">
              <div class="flex-row left-right-aligner">
                <label
                  id="company-settings-adastraenabled-label"
                  for="company-settings-adastraenabled"
                  class="control-label tw-font-normal"
                >
                  Enable Ad Astra
                </label>
                <mat-slide-toggle
                  class="mb-2"
                  name="adastraEnabled"
                  id="company-settings-adastraenabled"
                  [(ngModel)]="company.settings.adastraEnabled"
                  aria-labelledby="company-settings-adastraenabled-label"
                  (change)="updateEditableFields()"
                  [attr.aria-pressed]="company.settings.adastraEnabled"
                >
                </mat-slide-toggle>
              </div>
            </div>
          </div>
          @if (company.settings.adastraEnabled) {
            <div class="border-top tw-pt-8 tw-pb-4">
              <div class="form-group">
                <label
                  for="company-settings-adastraclientid"
                  class="control-label tw-font-normal"
                >
                  Tenant ID
                </label>
                <input
                  id="company-settings-adastraclientid"
                  name="company-settings-adastraclientid"
                  #adastraclientid="ngModel"
                  required
                  type="text"
                  class="form-control"
                  placeholder="Tenant ID"
                  [(ngModel)]="company.settings.adastraClientId"
                />
                <p
                  [shown]="
                    (adastraclientid.dirty || companyForm?.submitted) &&
                    adastraclientid.errors?.required
                  "
                  class="help-block validation-error-message-name text-danger"
                >
                  Ad Astra Tenant ID is required.
                </p>
              </div>
              <div class="form-group">
                <label
                  for="company-settings-adastraclientsecret"
                  class="control-label tw-font-normal"
                >
                  API Key
                </label>
                <div class="flex-row left-right-aligner">
                  <input
                    id="company-settings-adastraclientsecret"
                    name="company-settings-adastraclientsecret"
                    #adastraclientsecret="ngModel"
                    required
                    type="password"
                    class="form-control"
                    placeholder="API Key"
                    [readonly]="!adastraClientSecretEditable"
                    [(ngModel)]="company.settings.adastraClientSecret"
                    (blur)="onAdastraClientSecretBlur()"
                  />
                  @if (!adastraClientSecretEditable) {
                    <button
                      mat-icon-button
                      class="tw-ml-1 tw-border-solid tw-rounded-lg tw-border-gray-200"
                      type="button"
                      aria-label="Edit Ad Astra secret"
                      (click)="editAdastraClientSecret()"
                    >
                      <mat-icon svgIcon="edit" class="small" />
                    </button>
                  }
                </div>
                <p
                  [shown]="
                    (adastraclientsecret.dirty || companyForm?.submitted) &&
                    adastraclientsecret.errors?.required
                  "
                  class="help-block validation-error-message-name text-danger"
                >
                  Ad Astra API Key is required.
                </p>
              </div>
            </div>
          }
        </ng-container>
      </div>
    </div>
    <div class="settings-page-footer">
      <common-actions
        [actions]="actions"
        [saving]="companyService.loading"
        [changeDate]="company?.changeDate"
        [changedBy]="company?.changedBy"
      >
      </common-actions>
    </div>
  </form>
</div>
